module.exports = __webpack_public_path__ + "img/bell_2.f4893887.jpg";